import { Box, Link } from "@mui/material";

function Footer() {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        backgroundColor: "#f9f9f9",
        color: "#555",
        fontSize: { xs: "14px", sm: "16px", md: "18px", lg: "22px" },
        fontWeight: 500,
        padding: { xs: "6px 12px", sm: "8px 16px", md: "8px 20px" },
        textAlign: { xs: "right", sm: "right" },
        boxShadow: "0 -2px 6px rgba(0,0,0,0.05)",
      }}
    >
      Powered by{" "}
      <strong>
        <Link
          href="https://prism-ai.dev/"
          target="_blank"
          underline="hover"
          color="inherit"
          sx={{ fontWeight: 600 }}
        >
          Prism
        </Link>
      </strong>
    </Box>
  );
}

export default Footer;
